﻿import { Component } from "@basic-orange/component";

var styles = require('./styles.json');
var markerClustererStyles = require('./markerClustererStyles.json');

export default class GoogleMaps extends Component {
    constructor(elm, componentId) {
        super(elm, componentId);

        this.$elm = $(elm);
        this.$mapContainer = this.$elm;

        this.defaultLatLng = { lat: 52.349452, lng: 4.825878 };
        this.defaultZoom = 14;

        this.parkingLatLng = { lat: 52.346790, lng: 4.825200 };

        this.loadScriptInterval = null;
        this.loadMarkerClustererScriptInterval = null;

        this.map = null;
        this.key = this.data.key;

        this.markerCluster = null;
        this.useMarkerClusterer = false;

        this.hospitalText = `<strong><i class="fa fa-phone fa-flip"></i> 020 512 9111</strong><br />
<br />
Wij zijn telefonisch bereikbaar om uw vragen te beantwoorden en voor het maken van een afspraak. Als u vragen of opmerkingen heeft over de website, dan kunt u dit doen via communicatie@nki.nl.<br />
<br />
<strong>Bezoektijden</strong><br />
Algemeen 14:30 - 19:30<br />
IC 16:00 - 20:00<br />
<br />
<strong>Bezoekadres</strong><br />
Plesmanlaan 121<br />
1066 CX Amsterdam<br />
<br />
<strong>Postadres</strong><br />
Postbus 90203<br />
1006 BE Amsterdam`;

        this.parkingText = `<strong>Parkeren</strong><br />
Het parkeerterrein voor bezoekers vindt u vanaf de ingang aan de Plesmanlaan na 200 meter aan de rechterkant en vanaf de ingang aan de Louwesweg na 500 meter aan de linkerkant. (Het adres dat u kunt invoeren in uw navigatiesysteem luidt: Louwesweg 12). Het parkeerterrein staat duidelijk aangegeven op de borden. Bij de ingang van het parkeerterrein haalt u uw kaartje uit de automaat, waarna de slagboom open gaat. U kunt uw auto parkeren op het terrein of in het parkeergebouw. Als u uw auto heeft geparkeerd, loopt u naar de hoofdingang van het Antoni van Leeuwenhoek. Dit duurt ongeveer drie minuten. U kunt ook gebruikmaken van onze gratis shuttleservice. Deze rijdt van maandag tot en met vrijdag tussen 8.00 en 17.00 uur van en naar onze hoofdingang.<br />
<br />
De betaalautomaten bevinden zich in het parkeergebouw. Haalt u uw auto 's avonds op, dan kunt u de voetgangersdeur van het parkeergebouw met uw parkeerkaart openen. De ingang van het parkeergebouw is tevens de uitgang. De speedgates gaan bij het uitrijden vanzelf open. Bij de slagboom biedt u uw kaartje aan, waarna de slagboom open gaat.<br />
<br />
<strong>Parkeren voor mindervaliden</strong><br />
Aan beide zijden van het parkeergebouw zijn parkeerplaatsen beschikbaar voor mindervaliden (P1 en P2). Deze parkeerplaatsen zijn direct te bereiken vanaf de rijweg. In het parkeergebouw zijn op de begane grond en op de eerste etage zeventien parkeerplaatsen voor mindervaliden gerealiseerd.`;

        if (!window.GoogleMapsApiLoaded) {
            this.loadScriptAndInit();
        } else {
            this.init();
        }
    }

    loadScriptAndInit() {
        this.loadScript();

        this.loadScriptInterval = setInterval(function () {
            if (window.GoogleMapsApiLoaded) {
                clearInterval(this.loadScriptInterval);

                this.init();
            }
        }.bind(this), 100);
    }

    init() {
        if (this.useMarkerClusterer) {
            if (typeof window.MarkerClusterer === "undefined") {
                this.loadMarkerClustererScript();

                this.loadMarkerClustererScriptInterval = setInterval(function () {
                    if (typeof window.MarkerClusterer !== "undefined") {
                        clearInterval(this.loadMarkerClustererScriptInterval);

                        this.proceedInit();
                    }
                }.bind(this), 100);
            }
        } else {
            this.proceedInit();
        }
    }

    proceedInit() {
        this.map = new google.maps.Map(this.$mapContainer[0], {
            center: this.defaultLatLng,
            zoom: this.defaultZoom,
            styles: styles
        });

        this.createInfoWindow();
        this.loadData();
    }

    loadData() {
        this.createMarker(this.defaultLatLng, "De hoofdlocatie van het Antoni van Leeuwenhoek", this.map, this.hospitalText);
        this.createMarker(this.parkingLatLng, "Parkeerterrein: Louwesweg 12", this.map, this.parkingText, '/img/ga/pin-parking.png');
    }

    createMarker(latLng, title, map = null, content = null, icon = '/img/ga/pin.png') {
        var options = {
            position: latLng,
            icon: icon,
            title: title
        };

        if (map !== null) {
            options.map = map;
        }

        var marker = new google.maps.Marker(options);
        if (content !== '') {
            marker.addListener('click', function () {
                this.infowindow.setContent(content);
                this.infowindow.open(this.map, marker);
            }.bind(this));
        }

        return marker;
    }

    createInfoWindow() {
        this.infowindow = new google.maps.InfoWindow({
            content: '[no data]'
        });
    }

    loadScript() {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.key}&callback=onGoogleMapsApiLoaded`;
        script.setAttribute('async', '');
        script.setAttribute('defer', '');
        document.body.appendChild(script);
    }

    loadMarkerClustererScript() {
        //https://googlemaps.github.io/js-marker-clusterer/docs/reference.html
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js';
        document.body.appendChild(script);
    }
}